import { CommandNotificationModel } from './model/CommandNotificationModel';
import { BasePage } from 'src/pages/base.page';

export class GatewayNotification {

    private context: BasePage

    constructor(context: BasePage) {
        this.context = context
    }

    builder(commandNotificationModel: CommandNotificationModel) {
        commandNotificationModel.execute(this.context)
    }
}